import { render } from "./BaseCalendar.vue?vue&type=template&id=19e8076c&scoped=true&ts=true"
import script from "./BaseCalendar.vue?vue&type=script&lang=ts"
export * from "./BaseCalendar.vue?vue&type=script&lang=ts"

import "./BaseCalendar.vue?vue&type=style&index=0&id=19e8076c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e8076c"]])

export default __exports__